





































































import Vue from "vue";
export default Vue.extend({
  name: "ComponentExample",
  props: {
    exampleId: { type: String, required: true },
    tip: String,
    docs: { type: String, default: "" },
    title: { type: String, default: "" },
    condensed: { type: Boolean, default: false },
    fullscreenOnly: { type: Boolean, default: false },
    isFullscreenExample: { type: Boolean, default: false },
    component: Object,
    sourcecode: String
  },
  computed: {
    toggleCodeVisbilityIcon(): string[] {
      return [
        `sap-icon--navigation-${this.codeVisible ? "up" : "down"}-arrow`,
        "sap-icon--s"
      ];
    },
    toggleCodeVisbilityTitle(): string {
      return this.codeVisible ? "Hide Code" : "Show Code";
    }
  },
  data() {
    return {
      codeVisible: false
    };
  },
  methods: {
    toggleCodeVisibility(event: Event) {
      event.preventDefault();
      this.codeVisible = !this.codeVisible;
    },
    showExampleStandalone() {
      const routeData = this.$router.resolve({
        name: "example-demo",
        params: { id: this.exampleId }
      });
      window.open(routeData.href, "__blank");
    }
  }
});
